import { FC, useMemo } from 'react';
import { getCurrencySymbol } from 'utils/getCurrencySymbol';
import { IDiscountBadgeProps } from './types';
import styles from './discountBadge.module.scss';

export const DiscountBadge: FC<IDiscountBadgeProps> = ({ discountValue, discountType, price, currencyCode }) => {
  const discontColor = useMemo(() => {
    const discontRatio = discountType === 'percent' ? discountValue : (discountValue / price) * 100;
    if (discontRatio < 10) return 'discountGreen';
    else if (discontRatio < 30) return 'discountYellow';
    else if (discontRatio < 50) return 'discountOrange';
    return 'discountRed';
  }, [discountType, price, discountValue]);

  return (
    // <div className={`bg-gradient-to-b py-[4px] px-[8px] rounded-[6px] w-fit ${discontColor}`}>
    <div className={`${styles.discountBadge} ${styles[discontColor]}`}>
      <p className={styles.discountText}>
        -{discountValue}
        {discountType === 'percent' ? '%' : getCurrencySymbol(currencyCode)}
      </p>
    </div>
  );
};
